export class ScoreModel {
    points: number = 0;
    awards: number = 0;

}